import React, { Suspense, useContext, useState } from "react";

import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component

import FullLoader from "components/loader/full-loader";
import { Dropdown } from "react-bootstrap";

import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";

import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";

import Swal from "sweetalert2";
import { deleteRequest } from "services/api";
import { TripCreateProvider } from "contexts/v1/masterData/TripCreateContext";
import { useTrip } from "contexts/v1/masterData/TripContext";

// Main trips Page Component
const TripsPage = () => {
  const { trips, refetchTrip } = useTrip();
  console.log("trips", trips);
  const [currentPage, setCurrentPage] = useState(1); // For pagination

  const { handleSuccess, handleError, showCanvasHandler, handleSuccessToast } =
    useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Trip",
      <TripCreateProvider>
        <CreatePage
          // onSuccess={handleSuccess}
          onSuccess={() => {
            // handleSuccess(true, "Trip created successfully");
            handleSuccessToast(true, "Trip createing");
            refetchTrip();
          }}
          onError={handleError}
        />
      </TripCreateProvider>
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Trip",
      <TripCreateProvider>
        <CreatePage
          initialData={data}
          // onSuccess={handleSuccess}
          onSuccess={() => {
            // handleSuccess(true, "Trip updated successfully");
            handleSuccessToast(true, "Trip updateding");
            refetchTrip();
          }}
          onError={handleError}
        />
      </TripCreateProvider>
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/trip/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Data deleteing");
          refetchTrip();
        } else {
          handleError("Failed to delete trip");
        }
      }
    });
  };

  const totalPages = trips.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages,
    currentPage,
    onPageChange: setCurrentPage,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  if (trips.loading) return <FullLoader />;
  if (trips.error) return <Suspense error={trips.error} />;

  return (
    <LayoutDashboard>
      {/* trip page judul */}

      {/* Your content here */}
      <div className="container-fluid mt-5">
        {/* <h1>Trip Page</h1> */}

        <div className="table-container vh-100">
          <div className="search-container mb-3">
            {/* Search input */}
            <SearchInput />

            {/* Create button */}
            <button className="btn btn-primary" onClick={handleCreate}>
              Create
            </button>
          </div>

          {/* Table */}
          <div className="table table-responsive">
            <table className="table table-hover table-vcenter">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Trip</th>
                  <th>default_availability</th>
                  <th>start_time</th>
                  <th>end_time</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              {trips.data.length > 0 && (
                <tbody>
                  {trips.data.map((data, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.name}</td>
                        <td>{data.default_availability}</td>
                        <td>{data.start_time}</td>
                        <td>{data.end_time}</td>

                        <td className="text-end">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="default"
                              id="dropdownMenuButton1"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleUpdate(e, data)}
                              >
                                Edit
                              </Dropdown.Item>
                              {/* history */}
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(data.id);
                                }}
                              >
                                Remove
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              )}
            </table>
          </div>

          {/* Pagination */}
          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default TripsPage;

// Search Input Component
const SearchInput = () => {
  const { handleSearch, filterOptions } = useTrip();
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
